import { liquidGlassRowShadowSx, liquidGlassSurfaceFillSx } from '@focuslee/shared-mini-app';
import { Box, Stack } from '@mui/material';
import { GetActivityHistoryQuery } from '../../client/generated/graphql';
import { ActivityDayHeader } from './ActivityDayHeader';
import { ActivityTimelineItem } from './ActivityTimelineItem';

type GroupedEvent = {
    date: string;
    displayDate: string;
    events: GetActivityHistoryQuery['eventLogs'];
};

type ActivityTimelineProps = {
    groupedEvents: GroupedEvent[];
    maps: {
        questNameMap: Record<string, string>;
        questMap: Record<string, any>;
        goalNameMap: Record<string, string>;
        goalMap: Record<string, any>;
        rewardNameMap: Record<string, string>;
        categoryMap: Record<string, any>;
    };
};

export const ActivityTimeline = ({ groupedEvents, maps }: ActivityTimelineProps) => {
    return (
        <Stack spacing={2}>
            {groupedEvents.map(group => (
                <Stack key={group.date} spacing={1}>
                    <ActivityDayHeader displayDate={group.displayDate} />
                    <Box
                        data-testid={`activity-day-${group.date}`}
                        sx={{ width: '100%', borderRadius: '16px', overflow: 'hidden', ...liquidGlassRowShadowSx }}
                    >
                        <Box sx={{ borderRadius: 'inherit', ...liquidGlassSurfaceFillSx }}>
                            {group.events.map((item, index) => (
                                <ActivityTimelineItem
                                    key={item.id}
                                    item={item}
                                    showDivider={index > 0}
                                    questNameMap={maps.questNameMap}
                                    goalNameMap={maps.goalNameMap}
                                    rewardNameMap={maps.rewardNameMap}
                                    maps={maps}
                                />
                            ))}
                        </Box>
                    </Box>
                </Stack>
            ))}
        </Stack>
    );
};
